@let locale = languageService.getCurrentLocale();
@let d = details();

<section class="payment-summary">
  <div class="payment-summary-order">
    {{ 'global.order' | translate }} <strong>№{{ d.orderId }}</strong>
    {{ 'order-payment-details.from' | translate }}
    {{ d.orderCreatedAtIso | date:'medium' : undefined : locale }}
  </div>
  <div class="payment-summary-amount">
    <span class="payment-summary-amount-label">{{ 'order-payment-details.payment_amount' | translate }}</span>
    <span class="payment-summary-amount-value">{{ d.dueAmount | number:'1.0-2' : locale }} грн</span>
    @if (d.paidAmount > 0) {
      <span class="payment-summary-paid">
        {{ 'order-payment-details.already_paid' | translate }}
        {{ d.paidAmount | number:'1.0-2' : locale }}
        {{ 'order-payment-details.of' | translate }}
        {{ d.totalCost | number:'1.0-2' : locale }} грн
      </span>
    }
  </div>
  <div class="payment-summary-hint">
    <p>
      {{ 'order-payment-details.valid_until' | translate }}
      <strong>{{ d.validUntilIso | date:'d MMMM' : undefined : locale }}</strong>
    </p>
    <p>{{ 'order-payment-details.choose_hint' | translate }}</p>
  </div>
</section>

<ng-content />

@if (!d.accounts.length) {
  <div class="payment-details-error">{{ 'order-payment-details.no_accounts' | translate }}</div>
}

<div class="payment-accounts">
  @for (account of d.accounts; track account.bank + account.iban) {
    <section class="payment-account">
      <h2 class="payment-account-title">{{ account.bankName }}</h2>
      @if (account.note) {
        <p class="payment-account-note">{{ account.note }}</p>
      }

      @if (account.cardNumber) {
        <div class="payment-row">
          <div class="payment-row-body">
            <div class="payment-row-label">{{ 'order-payment-details.card_number' | translate }}</div>
            <div class="payment-row-value payment-row-value-mono payment-row-value-card">{{ formatCardNumber(account.cardNumber) }}</div>
          </div>
          <cmt-copy-button
            [value]="account.cardNumber"
            [subject]="'order-payment-details.card_number' | translate"
          />
        </div>

        <div class="payment-account-or"><span>{{ 'order-payment-details.or' | translate }}</span></div>
      }

      <div class="payment-row">
        <div class="payment-row-body">
          <div class="payment-row-label">{{ 'order-payment-details.iban' | translate }}</div>
          <div class="payment-row-value payment-row-value-mono payment-row-value-iban">{{ account.iban }}</div>
        </div>
        <cmt-copy-button
          [value]="account.iban"
          [subject]="'order-payment-details.iban' | translate"
        />
      </div>
      <div class="payment-row">
        <div class="payment-row-body">
          <div class="payment-row-label">{{ 'order-payment-details.recipient' | translate }}</div>
          <div class="payment-row-value">ФОП {{ account.recipientNameShort }}</div>
        </div>
        <cmt-copy-button
          [value]="'ФОП ' + account.recipientNameShort"
          [subject]="'order-payment-details.recipient' | translate"
        />
      </div>
      <div class="payment-row">
        <div class="payment-row-body">
          <div class="payment-row-label">{{ 'order-payment-details.tax_code' | translate }}</div>
          <div class="payment-row-value payment-row-value-mono">{{ account.taxCode }}</div>
        </div>
        <cmt-copy-button
          [value]="account.taxCode"
          [subject]="'order-payment-details.tax_code' | translate"
        />
      </div>
      <div class="payment-row">
        <div class="payment-row-body">
          <div class="payment-row-label">{{ 'order-payment-details.purpose' | translate }}</div>
          <div class="payment-row-value">{{ paymentReference(d) }}</div>
        </div>
        <cmt-copy-button
          [value]="paymentReference(d)"
          [subject]="'order-payment-details.purpose' | translate"
        />
      </div>
    </section>
  }
</div>

<section class="payment-after">
  <h2 class="payment-after-title">{{ 'order-payment-details.after_payment' | translate }}</h2>
  <p class="payment-after-line">
    <a
      class="payment-after-phone"
      href="tel:+380678811962"
    >
      +38 (067) 881-19-62
    </a>
    <a
      class="payment-after-link"
      href="viber://chat?number=%2B380678811962"
    >
      {{ 'order-payment-details.write_viber' | translate }}
    </a>
  </p>
  <p class="payment-after-line">
    <a
      class="payment-after-phone"
      href="tel:+380933444342"
    >
      +38 (093) 344-43-42
    </a>
    <a
      class="payment-after-link"
      href="https://t.me/+380933444342"
      target="_blank"
      rel="noopener"
    >
      {{ 'order-payment-details.write_telegram' | translate }}
    </a>
  </p>
</section>
